import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useRegistrationPagination } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/registration/hooks/useRegistrationPagination';
import {
    usePrevStep as useUpgradePrevStep,
    useUpgradePagination
} from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/hooks/useUpgradePagination';
import { FORGOT_PIN_STEP_NAMES } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ForgotPinStep/constants';
import { stepsNavigation } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/upgrade/steps/ForgotPinStep/helpers';
import { useRetailRegPagination } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailReg/hooks/useRetailRegPagination';
import {
    usePrevStep as useRetailUpgradePrevStep,
    useRetailUpgradePagination } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailUpgrade/hooks/useRetailUpgradePagination';
import {
    usePrevStep as useSlotUpgradePrevStep,
    useSlotUpgradePagination } from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/components/slotUpgrade/hooks/useSlotUpgradePagination';
import { useDistributorForRegType } from '@interlayer/js/app/components/main/Registration/hooks/useDistributorForRegType';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import {
    setAdditionalUpgradeData,
    setForgotPinData
} from '@interlayer/js/app/store/reducers/Registration/actions';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

export const useHandleBackReg = () => {
    const dispatch = useDispatch();
    const { handlerPrevStep: handlerPrevStepUpgrade } = useUpgradePagination();
    const { handlerPrevStep: handlerPrevStepReg } = useRegistrationPagination();
    const { handlerPrevStep: handlerPrevStepRetailRegistration } = useRetailRegPagination();
    const { handlerPrevStep: handlerPrevStepRetailUpgrade } = useRetailUpgradePagination();
    const { handlerPrevStep: handlerPrevStepSlotUpgrade } = useSlotUpgradePagination();
    const upgradePrevStep = useUpgradePrevStep();
    const retailUpgradePrevStep = useRetailUpgradePrevStep();
    const slotUpgradePrevStep = useSlotUpgradePrevStep();
    const {
        registrationNameStep,
        forgotPinData: { stepName },
        additionalUpgradeData: { isErrorStepFromSecretsQuestionStep, isForgotPinBlock }
    } = useRegistrationSelector();

    const handleBackUpgrade = useCallback(() => {
        if (!isForgotPinBlock) {
            handlerPrevStepUpgrade();

            return;
        }

        if (stepName === FORGOT_PIN_STEP_NAMES.USER_INFO_STEP) {
            dispatch(setAdditionalUpgradeData({ isForgotPinBlock: false }));

            return;
        }

        dispatch(setForgotPinData({
            stepName: stepsNavigation({ stepName, isErrorStepFromSecretsQuestionStep })
        }));
    }, [dispatch, handlerPrevStepUpgrade, isErrorStepFromSecretsQuestionStep, isForgotPinBlock, stepName]);

    return useDistributorForRegType({
        registration: handlerPrevStepReg,
        upgrade: upgradePrevStep ? handleBackUpgrade : null,
        retailReg: handlerPrevStepRetailRegistration,
        joinNow: null,
        retailUpgrade: retailUpgradePrevStep || registrationNameStep === STEP_NAMES.LOGIN_RETAIL_UPGRADE_STEP
            ? handlerPrevStepRetailUpgrade
            : null,
        slotUpgrade: slotUpgradePrevStep || registrationNameStep === STEP_NAMES.LOGIN_SLOT_UPGRADE_STEP
            ? handlerPrevStepSlotUpgrade
            : null
    });
};
